export const types = [
  { id: 0, name: '一般作业票' },
  { id: 1, name: '特殊作业票' },
  { id: 2, name: '其他票据' }
]

export const typeMap = types.reduce((acc, cur) => {
  acc[cur.id] = cur
  return acc
}, {})

export default {
  types,
  typeMap
}
